module.exports = {
      id: "time-24h-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#time-24h",
      toString: function () {
        return this.url;
      }
    }